import { httpRequest } from "@services/http";

/** The customer SFTP setup guide (PDF). Served by the API so it needs a login. */
export class CommandGetSftpInstructions {
  async run(): Promise<Blob> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/sftp/instructions`;
    return httpRequest<Blob>(url, { method: "GET", responseType: "blob" });
  }
}
